export const API_BASE_URL = 'https://arttokri.com'
// export const API_BASE_URL = 'http://localhost:5050'


export const PUBLIC_URL = 'https://arttokri.com/server/uploads'
// export const PUBLIC_URL =
//     'http://localhost:5050/server/uploads';
export const PLACEHOLDER_IMAGE = 'https://arttokri.com/server/uploads'

